import { type User } from '@firebase/auth'
import { createContext } from 'react'

const AuthUserContext = createContext<User | null>(null)

export default AuthUserContext
